import React, { useEffect, useState } from "react";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Form } from "react-bootstrap";
import "./SessionTokenBasedLocation.css";
import usePost from "../../../customhooks/UsePost";
import { useLoaderData } from "react-router-dom";
import { Notification, toaster } from "rsuite";
import { useTranslation } from "react-i18next";

const NewLocationInput2 = ({
  index = null,
  handlePlaceChange,
  value,
  onChange,
  placeholder,
  size,
  autoSuggestCssClassName,
  page,
  from = "",
  setInputField = () => {},
  inputField = "Single",
  companyID = ""
}) => {
  const { t } = useTranslation();
  const loaderDetails = useLoaderData();
  const {
    post: getLocationSuggestions,
    isLoading: getLocationSuggestionsLoading,
  } = usePost("/googleApi/getLocationSuggestions");
  const {
    post: getLocationPlaceDetails,
    isLoading: getLocationPlaceDetailsLoading,
  } = usePost("/googleApi/getLocationPlaceDetails");

  const [placePredictions, setPlacePredictions] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [updateSessionId, setUpdateSessionId] = useState("");

  const fetchPlacePredictions = async (text, triggerKey) => {
    try {
      let request = {
        prefix: text,
        session_id: "",
        region:
          loaderDetails?.themeVariables?.companyLocations?.length > 0
            ? loaderDetails?.themeVariables?.companyLocations
            : ["US"],
        source: "MRJSV4",
        auth_key: loaderDetails?.themeVariables?.authKey,
        isStreetRequired: true,
        companyID: companyID ||
          loaderDetails?.jobDetails?.companyID ||
          loaderDetails?.companyID ||
          ""
      };
      let suggestionsdata = await getLocationSuggestions(request);
      if (suggestionsdata?.result?.suggestions?.length > 0) {
        setUpdateSessionId(suggestionsdata?.result?.session_id);
        setPlacePredictions(suggestionsdata?.result?.suggestions);
        setInputField("Single");
      } else {
        setPlacePredictions([]);
        setInputField("Multiple");
        toaster.push(
          <Notification
            type={"warning"}
            header={t("attention", { defaultValue: "Attention" })}
            closable
          >
            {t("noSuggestionsFoundFillManually", {
              defaultValue:
                "No Suggestions found. Please enter the location details manually.",
            })}
          </Notification>,
          { placement: "topEnd" }
        );
      }
      setShowSuggestions(true);
    } catch (error) {
      console.error("Error fetching place predictions:", error);
    }
  };
  const handleKeyDown = async (e) => {
    if (e?.key === "Enter" && activeIndex === -1) {
      setShowSuggestions(false);
    }
    if (e?.key === "Enter" && page == "Search" && activeIndex === -1) {
      setShowSuggestions(false);
      //   setValue("");
    }
    if (e.key === "Enter" && value.trim() && activeIndex !== -1) {
      e.preventDefault();
      const selectedText = placePredictions[activeIndex]?.text;
      //   setValue(selectedText);
      handlePredictionClick(placePredictions[activeIndex], activeIndex);
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < placePredictions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : placePredictions.length - 1
      );
    }
  };

  const handleInputChange = (e) => {
    const value = e?.target?.value;
    if (value !== "") {
      fetchPlacePredictions(value);
    } else {
      setPlacePredictions([]);
      setShowSuggestions(false);
    }
  };

  const handlePredictionClick = async (item, index1) => {
    const updatedObj = {
      ...item,
      session_id: updateSessionId,
      auth_key: loaderDetails?.themeVariables?.authKey,
      source: "MRJSV4",
      isStreetRequired: true,
      companyID: companyID ? companyID : loaderDetails?.jobDetails?.companyID
    };
    let placeDetails = await getLocationPlaceDetails(updatedObj);
    if (placeDetails?.status) {
      let place = convertCustomAddressToGoogleFormat(
        placeDetails?.result?.details?.entity_details[0],
        placeDetails?.result?.details?.place_id,
        placeDetails?.result?.details?.formatted_address,
        placeDetails?.result?.details?.display_name
      );
      if (index !== null && index !== undefined && index !== "") {
        handlePlaceChange(place, index);
      } else {
        handlePlaceChange(place);
      }
      setPlacePredictions([]);
      setShowSuggestions(false);
      setActiveIndex(-1);
    }
  };

  const handleEnterSomeText = (event) => {
    if (event?.target?.value == "") {
      if (index !== null && index !== undefined && index !== "") {
        handlePlaceChange({ status: false }, index);
      } else {
        handlePlaceChange({ status: false });
      }
    }
  };

  return (
    <div className="position-relative">
      <Form.Control
        type="text"
        placeholder={placeholder || "Enter your location"}
        value={value}
        onChange={(e) => {
          handleInputChange(e);
          onChange(e);
        }}
        onKeyDown={handleKeyDown}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 300)}
        className={`custom-placeholder`}
        size={size || "md"}
        onInput={handleEnterSomeText}
      />
      {showSuggestions && placePredictions?.length > 0 && (
        <Card.Body
          className={`position-absolute p-0 m-0 z-3 bg-white shadow mt-1 cardBodyLocationCss ${
            autoSuggestCssClassName
              ? autoSuggestCssClassName
              : "custom-suggestion-box"
          } ${from == "education" ? "locationZIndex" : ""}`}
        >
          {placePredictions.map((item, index) => (
            <div
              className={`row border p-0 m-0 pb-2 pt-2 w-100 ${
                activeIndex === index ? "bg-light" : ""
              }`}
              role="button"
              key={item?.text}
              onClick={() => handlePredictionClick(item, index)}
            >
              <div className="col-12">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="text-primary me-1"
                />
                <span>{item?.text}</span>
              </div>
            </div>
          ))}
        </Card.Body>
      )}
    </div>
  );
};

export default NewLocationInput2;

function convertCustomAddressToGoogleFormat(customAddress, placeID, formatted_address, display_name) {
  const components = [];
  if (customAddress?.street) {
    components.push({
      longText: customAddress?.street,
      shortText: customAddress?.street,
      types: ["route"],
    });
  }
  if (customAddress?.sublocality) {
    components.push({
      longText: customAddress?.sublocality,
      shortText: customAddress?.sublocality,
      types: ["sublocality"],
    });
  }
  if (customAddress?.city) {
    components.push({
      longText: customAddress?.city,
      shortText: customAddress?.city,
      types: ["locality"],
    });
  }
  if (customAddress?.state) {
    components.push({
      longText: customAddress?.state,
      shortText:
        customAddress?.state_code?.toUpperCase() || customAddress?.state,
      types: ["administrative_area_level_1"],
    });
  }
  if (customAddress?.country) {
    components.push({
      longText: customAddress?.country,
      shortText:
        customAddress?.country_code?.toUpperCase() || customAddress?.country,
      types: ["country"],
    });
  }
  if (customAddress?.pincode) {
    components.push({
      longText: customAddress?.pincode,
      shortText: customAddress?.pincode,
      types: ["postal_code"],
    });
  }
  return {
    addressComponents: components,
    location: {
      lat: customAddress?.pin?.lat || null,
      lng: customAddress?.pin?.lon || null,
    },
    id: placeID ? placeID : "",
    status: true,
    formattedAddress: formatted_address,
    display_name: display_name
  };
}
